import { NotFound } from 'react-admin';
import { ResourceName } from 'dd-cms-client/app/resources';
import { hasUserAndTenantPermission } from 'dd-cms-client/auth/utils/permission';
import { Tenant } from 'dd-cms-client/auth/utils/tenant';
import { UserRole } from 'dd-cms-client/auth/utils/userRole';
import { StaticPageCreate } from './StaticPageCreate';
import { StaticPageEdit } from './StaticPageEdit';
import { StaticPageList } from './StaticPageList';

const staticPage = (userRole: UserRole, tenant: Tenant): Record<string, any> => {
  const hasPermissions = hasUserAndTenantPermission(ResourceName.STATIC_PAGE, userRole, tenant);

  return {
    create: hasPermissions ? StaticPageCreate : NotFound,
    edit: hasPermissions ? StaticPageEdit : NotFound,
    list: hasPermissions ? StaticPageList : NotFound,
  };
};

export {
  staticPage,
};
